import { DividerDateOverdueComponent } from './divider-date-overdue.component';

export default angular
  .module('sfMobile.components.divider-date-overdue', [
    'pascalprecht.translate',
    'sfMobile.components.divider',
  ])
  .component('sfDividerDateOverdue', DividerDateOverdueComponent).name;
